<template>
    <el-select ref="sel" placeholder="请选择" filterable :loading="loading" remote-show-suffix :suffix-icon="Search" reserve-keyword v-bind="$attrs">
        <el-option v-for="item in opts" :key="item[valueKey]" :label="item[labelKey]" :value="item[valueKey]" :style="`width: ${unrefElement(sel)?.offsetWidth}px`">
            <slot name="option" :row="item">
                <div v-html="highlight(item[labelKey])" truncate box-border />
            </slot>
        </el-option>

        <template v-for="(slot, name) in $slots" #[name]="scope">
            <slot :name="name" v-bind="scope" />
        </template>

        <el-option v-show="!opts.length" :value="NaN" disabled text-center>无数据</el-option>
    </el-select>
</template>

<script setup>
import { computed, ref } from 'vue';
import { toReactive, unrefElement } from '@vueuse/core';
import { Search } from '@element-plus/icons-vue';
import { useRequest } from 'vue-request';
import { unFn } from '@/utils';

const props = defineProps({
    options: [Array, Promise, Function],
    labelKey: { type: String, default: 'label' },
    valueKey: { type: String, default: 'value' },
})

const sel = ref({})

const keyword = ref('')

const { data, loading, run, refresh } = useRequest(
    async (kw) => {
        keyword.value = kw
        return await unFn(props.options, kw)
    },
    { manual: true }
)

const opts = computed(() => {
    const list = (typeof props.options == 'function' ? data.value : props.options) || []
    return list.map(nOpt)
})

function nOpt(opt) {
    return typeof opt == 'object' ? opt : { [props.labelKey]: opt, [props.valueKey]: opt }
}

function highlight(txt) {
    const kw = keyword.value.trim()
    if (!kw) return txt
    return txt.replace(new RegExp(kw, 'ig'), `<span style="color: var(--el-color-primary)">${kw}</span>`)
}

// defineExpose(toReactive(sel))
defineExpose({ refresh })
</script>

<style scoped lang="scss">
:deep(.el-select__caret.is-reverse) {
    transform: none !important;
}
</style>